import { all } from 'typed-redux-saga';
import editorPage from 'src/pages/editor/saga';
import alerts from 'src/components/alert/saga';
import application from 'src/saga';
import scenes from 'src/components/scenes/saga';

export default function* allSagas() {
    return yield* all([editorPage(), alerts(), application(), scenes()]);
}
